import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
/* import { Grid, Tooltip, useMediaQuery } from "@mui/material"; */

// import generatePDF from 'react-to-pdf';

/* import iconGuardar from "../img/iconGuardar.svg"; */
/* import iconVistaPrevia from "../img/iconVistaPrevia.svg";
import iconDuplicar from "../img/iconDuplicar.svg";
import iconCompartir from "../img/iconCompartir.svg";
import iconCompartirFlecha from "../img/iconCompartirFlecha.svg"; */
// import iconFavorito from '../img/iconFavorito.svg'

import { usePptos } from "../../../hooks/usePptos";
import { useBuy } from "../../../hooks/useBuy";
import { useInvoices } from "../../../hooks/useInvoices";

import {
  iniSaveBudget,
  iniUpdateBudget,
  iniBudgetPreview,
  iniCreateBudgetDuplicate,
  iniUpdateBudgetModeTemplate,
  iniCloseBudget,
} from "../../../redux/actions/pptos";

import VistaPrevia from "../vistaPreviaPdf/VistaPrevia";
import { VistaPreviaNP } from "../vistaPreviaPdfNP/VistaPreviaNP";

import { DialogApprove } from "../approve/DialogApprove";
import { ValidateProfit } from "../validate/ValidateProfit";
import { RequestValidation } from "../validate/RequestValidation";
import { RestartValidation } from "../validate/RestartValidation";
/* import { ButtonOptionsValidacion } from "./ButtonOptionsValidacion"; */
import { RejectValidation } from "../validate/RejectValidation";
import { ComprasModalNuevoGasto } from "../../compras/form/ComprasModalNuevoGasto";
import { DialogFormBuy } from "../../compras/miniForm/DialogFormBuy";
import { DialogAnular } from "../anular/DialogAnular";

// import { DialogFormInvoice } from '../../invoices/miniForm/DialogFormInvoice'
import { InvoiceModalNuevo } from "../../invoices/form/InvoiceModalNuevo";
import { VersionesDialogList } from "../../ppto_versiones/VersionesDialogList";
import { getItemsSelected } from "../../../helpers/pptos";
import { DialogNewTemplates } from "../templates/DialogNewTemplates";
/* import { ButtonsActions } from "../../reusableUI/ButtonsActions"; */
import { PopoverList } from "../../reusableUI/PopoverList";
import { DialogAddProjectionsByItems } from "../Projections/DialogAddProjectionsByItems";
// import { VistaPreviaNewTest } from '../vistaPreviaPdf/VistaPreviaNewTest'

/* import { Buttons } from "../../reusableUI/v2UI/Buttons";
import { Save } from "lucide-react"; */
import { ButtonsBox } from "./ButtonsBox";

export const FormActions = ({
  loadIniBudget,
  openInfoInicial,
  setOpenInfoInicial,
}) => {
  const { initExportCliente } = usePptos();
  const { detailBuy, initCreateBuy } = useBuy();
  const { detailInvoice, initCreateInvoice } = useInvoices();

  const [openVistaPrevia, setOpenVistaPrevia] = useState(false);
  const [openVistaPreviaNP, setOpenVistaPreviaNP] = useState(false);
  const [openApprove, setOpenApprove] = useState(false);
  const [actionApprove, setActionApprove] = useState("");

  const [openValidate, setOpenValidate] = useState(false);
  const [openRequestValidation, setOpenRequestValidation] = useState(false);
  const [openRestartValidation, setOpenRestartValidation] = useState(false);
  const [openRejectValidate, setOpenRejectValidate] = useState(false);

  const [openNewBuy, setOpenNewBuy] = useState(false);
  const [openNewInvoice, setOpenNewInvoice] = useState(false);
  const [openAnular, setOpenAnular] = useState(false);
  const [openVersiones, setOpenVersiones] = useState(false);
  const [openTemplates, setOpenTemplates] = useState(false);

  const [openAddProjections, setOpenAddProjections] = useState(false);
  const [itemsSelectedProjections, setItemsSelectedProjections] = useState({});

  const [openExtendedMode, setOpenExtendedMode] = useState(false);
  const [dataFormBuy, setDataFormBuy] = useState({});
  const [listOptionsPoperver, setListOptionsPoperver] = useState([]);

  const urlParams = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const detailBudget = useSelector((state) => state.ppto.detail);
  const {
    id,
    numero,
    referencia,
    id_cliente,
    total_cliente,
    template_mode,
    estado_cierre,
    id_moneda,
    valor_tipo_cambio,
  } = detailBudget;

  const generalParams = useSelector((state) => state.general);
  // const { id: idEmpPro } = generalParams.info
  const generalDetail = generalParams.detail;

  // const [openVistaPreviaTest, setOpenVistaPreviaTest] = useState(false)

  const saveBudget = () => {
    if (
      parseFloat(id_moneda) === 4 &&
      parseFloat(valor_tipo_cambio) === 0 &&
      !template_mode
    ) {
      toast.warning("Falta ingresar tipo de cambio");
      setOpenInfoInicial(true);
      return false;
    }

    if (id > 0 && !template_mode) {
      const originalDetailRaw = localStorage.getItem("budget-detail-init-data");
      const originalDetailObj = originalDetailRaw
        ? JSON.parse(originalDetailRaw)
        : null;
      const isDirty =
        JSON.stringify(detailBudget) !== JSON.stringify(originalDetailObj);
      if (!isDirty) {
        toast.info("No se han detectado cambios para guardar");
        return false;
      }

      dispatch(iniUpdateBudget(detailBudget, urlParams.budgetId));
    } else {
      if (template_mode) {
        dispatch(iniUpdateBudgetModeTemplate(detailBudget));
      } else {
        dispatch(iniSaveBudget(detailBudget, navigate));
      }
    }
  };

  const budgetPreview = () => {
    setOpenVistaPrevia(true);
    dispatch(iniBudgetPreview());
  };

  // const budgetPreviewTest = () => {
  //     setOpenVistaPreviaTest(true)
  //     dispatch(iniBudgetPreview())
  // }

  const duplicateBudget = () => {
    dispatch(iniCreateBudgetDuplicate(detailBudget));
    navigate(`/ppto/0`);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const idx = open ? "simple-popover" : undefined;

  const shareBudget = (event) => {
    setListOptionsPoperver([
      {
        id: "1",
        name: "EXCEL",
        handleFn: shareExcel,
        icon_class: "bi bi-file-earmark-excel",
        show: true,
      },
      {
        id: "2",
        name: "PDF",
        handleFn: sharePdf,
        icon_class: "bi bi-filetype-pdf",
        show: true,
      },
      // { id: '3', name: 'NP', handleFn: sharePdfNP, icon_class: 'bi bi-filetype-pdf', show: (parseFloat(idEmpPro) === 15 || parseFloat(idEmpPro) === 4) }
    ]);

    setAnchorEl(event.currentTarget);
  };

  const approveBudget = (type) => {
    if (type === "approve") {
      if (referencia === "") {
        toast.warning("Falta ingresar nombre o referencia de la venta");
        return false;
      }

      if (parseFloat(id_cliente) === 0) {
        toast.warning("Falta seleccionar cliente");
        return false;
      }

      if (total_cliente === 0) {
        toast.warning("Falta ingresar monto de la venta");
        return false;
      }
    }

    setActionApprove(type);
    setOpenApprove(true);
  };

  const shareExcel = () => {
    initExportCliente({ id, numero });
  };

  const sharePdf = () => {
    budgetPreview();
  };

  // const sharePdfNP = () => {
  //     setOpenVistaPreviaNP(true)
  //     dispatch(iniBudgetPreview())
  // }

  // const copyUrl = () => {
  //     const url = document.URL
  //     navigator.clipboard.writeText(url)
  //     toast.info('copiado!')
  // }

  const handleTemplate = () => {
    setOpenTemplates(true);
  };

  const handleAddBuy = async () => {
    const pendingFlowsEx = detailBudget?.projections?.filter(
      (it) => it.tipo_flujo === "egreso" && it.estado === "pendiente",
    );

    if (pendingFlowsEx.length > 0) {
      toast.warning("Debes crear gastos desde flujos proyectados");
      return false;
    }

    const itemsSelected = await getItemsSelected(detailBudget.items);

    if (itemsSelected.length === 0) {
      toast.warning("Debes seleccionar al menos un ítem");
      return false;
    }

    /*         console.log({ itemsSelected })
     */
    await initCreateBuy({
      origen: "ventas",
      itemsSelected,
      detailBudget,
      generalParams,
    });

    setOpenNewBuy(true);
  };

  const handleAddProjections = async (type) => {
    const itemsSelected = await getItemsSelected(detailBudget.items);
    // console.log({ itemsSelected })

    if (itemsSelected.length === 0 && type === "egreso") {
      toast.warning("Debes seleccionar al menos un ítem");
      return false;
    }

    setItemsSelectedProjections({
      itemsSelected,
      type,
    });

    setOpenAddProjections(true);
  };

  const handleOpenExtendedMode = (dataForm) => {
    setDataFormBuy(dataForm);
    setOpenExtendedMode(true);
    setOpenNewBuy(false);
  };

  const handleAddInvoice = async () => {
    await initCreateInvoice(detailBudget, generalDetail);
    setOpenNewInvoice(true);
  };

  const handleVersiones = () => {
    setOpenVersiones(true);
  };

  const openCloseBudget = (event) => {
    const isClosed = estado_cierre === "cerrado";
    const isStandby = estado_cierre === "pausado";

    setListOptionsPoperver([
      {
        id: 1,
        name: "Abrir",
        handleFn: () => {
          handleCloseBudget("abierto");
        },
        icon_class: "bi bi bi-unlock",
        show: isClosed ? true : false,
        icon_color: null,
      },
      {
        id: 2,
        name: "Cerrar",
        handleFn: () => {
          handleCloseBudget("cerrado");
        },
        icon_class: "bi bi bi-lock",
        show: !isClosed ? true : false,
        icon_color: null,
      },
      {
        id: 3,
        name: "Stand-by",
        handleFn: () => {
          handleCloseBudget("pausado");
        },
        icon_class: "bi bi-pause-circle",
        show: !isStandby && !isClosed ? true : false,
        icon_color: null,
      },
      {
        id: 4,
        name: "Reactivar",
        handleFn: () => {
          handleCloseBudget("abierto");
        },
        icon_class: "bi bi-play-circle",
        show: isStandby ? true : false,
        icon_color: null,
      },
    ]);

    setAnchorEl(event.currentTarget);
  };

  const openCreateFlow = (event) => {
    setListOptionsPoperver([
      {
        id: 1,
        name: "Crear flujo ingreso",
        handleFn: () => {
          handleAddProjections("ingreso");
        },
        icon_class: "bi bi-plus-circle-fill",
        show: true,
        icon_color: "green",
      },
      {
        id: 2,
        name: "Crear flujo egreso",
        handleFn: () => {
          handleAddProjections("egreso");
        },
        icon_class: "bi bi-plus-circle-fill",
        show: true,
        icon_color: "red",
      },
    ]);

    setAnchorEl(event.currentTarget);
  };

  const handleCloseBudget = async (status) => {
    dispatch(iniCloseBudget(detailBudget.id, status));
  };

  return (
    <>
      {openNewBuy && (
        <DialogFormBuy
          title="Nuevo gasto"
          open={openNewBuy}
          setOpen={setOpenNewBuy}
          initialState={detailBuy}
          handleOpenExtendedMode={handleOpenExtendedMode}
          loadIniBudget={loadIniBudget}
        />
      )}

      {openAddProjections && (
        <DialogAddProjectionsByItems
          open={openAddProjections}
          setOpen={setOpenAddProjections}
          params={itemsSelectedProjections}
        />
      )}

      {openExtendedMode && (
        <ComprasModalNuevoGasto
          title="Nuevo gasto"
          open={openExtendedMode}
          setOpenExtendedMode={setOpenExtendedMode}
          initialState={dataFormBuy}
          loadIniBudget={loadIniBudget}
        />
      )}

      {openNewInvoice && (
        <InvoiceModalNuevo
          title="Nueva factura"
          open={openNewInvoice}
          setOpen={setOpenNewInvoice}
          initialState={detailInvoice}
          loadIniBudget={loadIniBudget}
        />
      )}

      {openVistaPrevia && (
        <VistaPrevia open={openVistaPrevia} setOpen={setOpenVistaPrevia} />
      )}

      {/* {openVistaPreviaTest &&
                <VistaPreviaNewTest
                    open={openVistaPreviaTest}
                    setOpen={setOpenVistaPreviaTest}
                />
            } */}

      {openVistaPreviaNP && (
        <VistaPreviaNP
          open={openVistaPreviaNP}
          setOpen={setOpenVistaPreviaNP}
        />
      )}

      {openApprove && (
        <DialogApprove
          budgetId={id}
          type={actionApprove}
          open={openApprove}
          setOpen={setOpenApprove}
        />
      )}

      {openValidate && (
        <ValidateProfit
          budgetId={id}
          open={openValidate}
          setOpen={setOpenValidate}
        />
      )}

      {openRejectValidate && (
        <RejectValidation
          budgetId={id}
          open={openRejectValidate}
          setOpen={setOpenRejectValidate}
        />
      )}

      {openRequestValidation && (
        <RequestValidation
          budgetId={id}
          open={openRequestValidation}
          setOpen={setOpenRequestValidation}
        />
      )}

      {openRestartValidation && (
        <RestartValidation
          budgetId={id}
          open={openRestartValidation}
          setOpen={setOpenRestartValidation}
        />
      )}

      {openAnular && (
        <DialogAnular budgetId={id} open={openAnular} setOpen={setOpenAnular} />
      )}

      {openTemplates && (
        <DialogNewTemplates
          open={openTemplates}
          setOpen={setOpenTemplates}
          detailBudget={detailBudget}
        />
      )}

      {openVersiones && (
        <VersionesDialogList
          open={openVersiones}
          setOpen={setOpenVersiones}
          title="Versiones"
          idPpto={id}
        />
      )}

      <ButtonsBox
        saveBudget={saveBudget}
        budgetPreview={budgetPreview}
        duplicateBudget={duplicateBudget}
        shareBudget={shareBudget}
        approveBudget={approveBudget}
        setOpenAnular={setOpenAnular}
        handleTemplate={handleTemplate}
        setOpenValidate={setOpenValidate}
        setOpenRequestValidation={setOpenRequestValidation}
        setOpenRestartValidation={setOpenRestartValidation}
        setOpenRejectValidate={setOpenRejectValidate}
        handleAddBuy={handleAddBuy}
        handleAddInvoice={handleAddInvoice}
        handleVersiones={handleVersiones}
        openCloseBudget={openCloseBudget}
        handleAddProjections={handleAddProjections}
        openCreateFlow={openCreateFlow}
      />

      <PopoverList
        open={open}
        idx={idx}
        anchorEl={anchorEl}
        handleClose={handleClose}
        list_options={listOptionsPoperver}
      />
    </>
  );
};
